module.exports = __webpack_public_path__ + "static/media/142.dcef87a4.webp";